import {QueryFunctionContext} from 'react-query';
import request from '../axios';

export const getPostReport = async (ctx: QueryFunctionContext) => {
  const params = ctx.queryKey[1];
  const {data}: {data: Array<IAdReport>} = await request.get(
    `/api/v2/store/post-view/` + params,
  );
  return data;
};

